import { z } from 'zod';
export const DeadlineType = z.enum([
    'hearing',
    'response',
    'discovery',
    'statute',
    'trial',
    'custom',
]);
export const CreateDeadlineSchema = z.object({
    caseNumber: z.string().max(100).optional(),
    caseTitle: z.string().max(500).optional(),
    title: z.string().min(1).max(255),
    dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD'),
    deadlineType: DeadlineType.default('custom'),
    notes: z.string().max(2000).optional(),
});
export const UpdateDeadlineSchema = CreateDeadlineSchema.partial();
export const DeadlineListQuerySchema = z.object({
    days: z.coerce.number().int().min(1).max(365).default(90),
    includeOverdue: z.coerce.boolean().default(true),
});
